import React, { useEffect, useState } from 'react';
import { 
  Box, Typography,  Grid, Button, Skeleton, Tabs, Tab, Paper, Fade 
} from '@mui/material';
import { AgendamentoService } from '../../services/agendamentoservice';
import { useAgendamentoStore } from '../../store/useAgendamentoStore';
import { InfoAgendamento } from '../agendamento/InfoAgendamento';


export const StepHorario: React.FC<{ servicoId: number; unidadeId: number }> = ({ servicoId, unidadeId }) => {
  const { setHorario, setProfissionaisDisponiveis } = useAgendamentoStore();
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [mapaGeral, setMapaGeral] = useState<Record<string, string[]>>({});

  useEffect(() => {
    const carregarAgendas = async () => {
      try {
        const dados = await AgendamentoService.listarHorarios(servicoId, unidadeId);
        setProfissionaisDisponiveis(dados);
        
        const consolidado: Record<string, Set<string>> = {};
        
        dados.forEach((prof) => {
          Object.entries(prof.diaHorarios).forEach(([data, horas]) => {
            if (!consolidado[data]) consolidado[data] = new Set();
            (horas as string[]).forEach(h => consolidado[data].add(h.substring(0, 5)));
          });
        });

        const mapaFinal: Record<string, string[]> = {};
        Object.keys(consolidado).forEach(data => {
          mapaFinal[data] = Array.from(consolidado[data]).sort();
        });

        setMapaGeral(mapaFinal);
      } catch (error) {
        console.error("Erro ao carregar horários", error);
      } finally {
        setLoading(false);
      }
    };

    carregarAgendas();
  }, [servicoId, unidadeId, setProfissionaisDisponiveis]);

  if (loading) return <Skeleton variant="rounded" height={300} sx={{ borderRadius: 6 }} />;

  const datasDisponiveis = Object.keys(mapaGeral).sort();
  const dataSelecionada = datasDisponiveis[tabIndex];
  const horariosDoDia = mapaGeral[dataSelecionada] || [];

  return (
    <Fade in timeout={500}>
      <Box>
        <InfoAgendamento />
        
        <Typography variant="h6" fontWeight={800} mb={2}>Selecione o Dia</Typography>
        <Tabs 
          value={tabIndex} 
          onChange={(_, v) => setTabIndex(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ 
            mb: 4, 
            '& .MuiTabs-indicator': { bgcolor: 'var(--color-primary)' },
            '& .MuiTab-root.Mui-selected': { color: 'var(--color-primary)', fontWeight: 800 }
          }}
        >
          {datasDisponiveis.map((data) => (
            <Tab 
              key={data} 
              label={
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="caption" sx={{ display: 'block', opacity: 0.7 }}>
                    {new Date(data + 'T00:00:00').toLocaleDateString('pt-BR', { weekday: 'short' })}
                  </Typography>
                  <Typography variant="body1" fontWeight={700}>
                    {new Date(data + 'T00:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })}
                  </Typography>
                </Box>
              } 
            />
          ))}
        </Tabs>

        <Typography variant="h6" fontWeight={800} mb={2}>Horários disponíveis</Typography>
        <Grid container spacing={2}>
          {horariosDoDia.map((hora) => (
            <Grid key={hora} size={{ xs: 4, sm: 3, md: 2 }}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => setHorario(dataSelecionada, hora)}
                sx={{ 
                  borderRadius: 3, 
                  py: 1.5,
                  fontWeight: 700,
                  color: 'var(--color-text)',
                  borderColor: 'rgba(0,0,0,0.1)',
                  '&:hover': { borderColor: 'var(--color-primary)', bgcolor: 'rgba(0,0,0,0.02)' }
                }}
              >
                {hora}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Fade>
  );
};